import {
  Avatar,
  Badge,
  Button,
  Card,
  CardMedia,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  Apartment,
  Error,
  MoreHoriz,
  Room,
  Room as RoomIcon,
} from '@material-ui/icons';
import { FindInPage } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import { getNotifications } from '@webapps/business';
import {
  useAuth,
  useNotif,
  useQuery,
  useStrophe,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Partenaire from 'components/Icons/Partenaire';
import Team from 'components/Icons/Team';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import theme from '../theme';

const {
  colors: { background },
} = theme;

const Synthesis = ({
  sector,
  coverImage,
  name,
  profileImage,
  slogan,
  cp,
  city,
  location,
  presentation,
  verified,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { fontSizes, spacing },
  } = useStyles(styles);

  const [anchorVitrine, setAnchorVitrine] = useState(null);
  const openVitrineMenu = Boolean(anchorVitrine);
  const history = useHistory();
  const isTruncated = sector?.length > 22;
  const sectorText = isTruncated ? `${sector.slice(0, 22)}...` : sector;
  const [badgeCount, setBadgeCount] = useState(null);
  const { messagesReceived } = useStrophe();
  const { idUser } = useAuth();
  const { totalNotif } = useNotif();

  const { data: { content: notifs = [], totalElements } = {} } = useQuery(
    getNotifications,
    {
      key: ['notifsStudent', idUser],
      variables: {
        id: idUser,
        page: 0,
        size: 8,
        status: 'unread',
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  useEffect(() => {
    setBadgeCount(messagesReceived?.length);
  }, [messagesReceived]);

  return (
    <Grid container>
      <Grid item xs={12}>
        {coverImage ? (
          <Card
            style={{
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              borderBottomLeftRadius: '0px',
              borderBottomRightRadius: '0px',
            }}
            elevation={0}
          >
            <CardMedia
              component="img"
              alt="cover image"
              image={coverImage}
              elevation={0}
            />
          </Card>
        ) : (
          /*<img
            src={coverImage}
            className={cx(classes.title)}
            alt="cover image"
          />*/
          <Paper
            className={cx(
              classes.title,
              css({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                background: '#5A6DA1',
              })
            )}
            elevation={0}
          >
            <div className={css({ fontSize: fontSizes(35) })}>{name}</div>
          </Paper>
        )}
      </Grid>
      <Grid
        className={css({
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'space-between',
        })}
        item
        xs={12}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <div style={{ margin: '20px' }}>
            {profileImage ? (
              <Avatar className={classes.avatar} src={profileImage} />
            ) : (
              <Avatar className={classes.avatar}>{name?.substr(0, 1)}</Avatar>
            )}
          </div>
          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            })}
          >
            <Grid className={css({ margin: '0px 20px' })}>
              <div className={classes.name}>
                {name}
                <div
                  className={css({
                    marginLeft: spacing(1),
                  })}
                >
                  <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
                </div>
                {/* {verified && (
                  <VerifiedUserIcon
                    className={css({ marginLeft: spacing(1) })}
                    color="primary"
                  />
                )} */}
              </div>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                {slogan && typeof slogan === 'string' ? parse(slogan) : null}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: 10,
                }}
              >
                <div className={classes.infoDetails}>
                  <Apartment
                    style={{ marginRight: spacing(1) }}
                    className={classes.icon}
                  />
                  {isTruncated ? (
                    <LightTooltip title={sector} placement="top">
                      <Typography className={classes.address}>
                        {sectorText}
                      </Typography>
                    </LightTooltip>
                  ) : (
                    <Typography className={classes.address}>
                      {sectorText}
                    </Typography>
                  )}
                </div>
                <div className={classes.infoDetails}>
                  <LightTooltip title={location} placement="top">
                    <Typography className={classes.address}>
                      <Room className={classes.icon} />
                      {cp}, {city}
                    </Typography>
                  </LightTooltip>
                </div>
              </div>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  color="secondary"
                  variant="contained"
                  className={classes.btn}
                  style={{
                    borderRadius: '400px',
                    marginTop: '20px',
                  }}
                  onClick={() =>
                    history.push(ROUTES_PATH.BUSINESS_NOTIFICATIONS)
                  }
                >
                  {notifs.length > 0 ? totalNotif : '0'}{' '}
                  {/* Affiche la valeur de totalNotif si notifs contient des éléments */}
                  <FormattedMessage id="business.dashboard.dashboardBtns.tasksbtn" />
                </Button>
              </Grid>
            </Grid>
            <Divider style={{ margin: '20px 0px 20px 0px' }} />
            <Grid className={css({ margin: '0px 20px 20px 20px' })}>
              <div>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Button
                    startIcon={<FindInPage />}
                    color="primary"
                    variant="contained"
                    className={classes.btn}
                    style={{ borderRadius: '400px' }}
                    onClick={() => {
                      history.push(ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS, {
                        openCreateAnnonce: true,
                      });
                    }}
                  >
                    <FormattedMessage id="business.annoncesCandidats.btnPublierAnnonce" />
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Button
                    startIcon={<Partenaire />}
                    color="primary"
                    variant="contained"
                    className={classes.btn}
                    onClick={() => {
                      history.push(ROUTES_PATH.BUSINESS_PARTNERS, {
                        addPartner: true,
                      });
                    }}
                    style={{ borderRadius: '400px', marginTop: '10px' }}
                  >
                    <FormattedMessage id="business.dashboard.dashboardBtns.partnerbtn" />
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Button
                    startIcon={<Team />}
                    color="primary"
                    variant="contained"
                    className={classes.btn}
                    onClick={() => {
                      history.push(ROUTES_PATH.BUSINESS_TEAMS, {
                        openInviteStudents: true,
                      });
                    }}
                    style={{ borderRadius: '400px', marginTop: '10px' }}
                  >
                    <FormattedMessage id="business.dashboard.dashboardBtns.studentinvitbtn" />
                  </Button>
                </Grid>
                <Grid className={classes.infoContainer} container></Grid>
                {/* <Grid className={classes.infoContainer} container>
                  <Grid className={classes.infoTitle} item xs={12} sm={4} md={3} >
                      <FormattedMessage id="vitrine.specialization" />
                  </Grid>
                  <Grid item xs={12} md={8}>
                      <div className={classes.infoDetails}>{specialization || 'À remplir'}</div>
                  </Grid>
              </Grid> */}
                <Grid className={classes.infoContainer} container></Grid>
              </div>
            </Grid>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    borderRadius: 10,
    background,
    marginTop: spacing(3),
  },
  containerInfo: {
    padding: spacing(3),
  },
  title: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: '100%',
    height: '15vh',
    '@media only screen and (max-width:1200px)': {
      height: '15vh',
    },
    '@media only screen and (max-width:768px)': {
      height: '10vh',
    },
  },
  avatar: {
    marginTop: '-60px',
    height: 80,
    width: 80,
    border: '1px solid #C0D9FF',
    '@media only screen and (max-width:768px)': {
      height: 60,
      width: 60,
    },
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15px' },
    fontWeight: 600,
    fontFamily: 'Montserrat',
    color: '#152652',
    display: 'flex',
    alignItems: 'center',
    // marginLeft: spacing(1),
  },
  infoDetails: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 400,
    color: '#5D75A8',
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    marginLeft: '-6px',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 400,
    color: '#5D75A8',
    display: 'flex',
    alignItems: 'center',
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  iconsDesktop: {
    display: 'flex',
    '@media screen and (max-width: 768px)': {
      display: 'none',
    },
  },
  iconsMobile: {
    '@media screen and (min-width: 768px)': {
      display: 'none',
    },
  },
  icon: {
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  btn: {
    boxShadow: 'none',
    width: '100%',
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
  },
  badge: {
    '.MuiBadge-anchorOriginTopRightRectangle': {
      transform: 'translate(70%, 60%)',
    },
    '@media only screen and (max-width:768px)': {
      '.MuiBadge-anchorOriginTopRightRectangle': {
        transform: 'none',
      },
    },
  },
});

Synthesis.propTypes = {
  name: PropTypes.string,
  coverImage: PropTypes.string,
  profileImage: PropTypes.string,
  presentation: PropTypes.string,
};

const LightTooltip = withStyles(({ shadows, fontSizes }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
  },
}))(Tooltip);

export default Synthesis;

// <Paper
//     className={cx(
//         classes.title,
//         css({
//             background: coverImage ? `url(${coverImage}) no-repeat` : '#5A6DA1',
//             backgroundSize: 'contain',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             position: 'relative',
//         })
//     )}
//     elevation={0}
// >
//     {!coverImage && (
//         <div className={css({fontSize: fontSizes(35)})}>{name}</div>
//     )}
// </Paper>
